import ApplicationSerializer from './application';

export default class VisitorProfileSerializer extends ApplicationSerializer {
  // photo-url and legal-name are read-only derived fields on the backend
  // VisitorProfileResource. Sending them on PATCH causes a 500 because the
  // resource has no corresponding setters.
  attrs = {
    photoUrl: { serialize: false },
    legalName: { serialize: false },
  };
}

declare module 'ember-data/types/registries/serializer' {
  export default interface SerializerRegistry {
    'visitor-profile': VisitorProfileSerializer;
  }
}
